<template>
  <div>
    <b-row class="mb-1">
      <b-col
        lg="6"
        md="6"
        sm="12"
      >
        <div class="d-flex align-items-center">
          <b-link
            style="font-size: 26px; color: #fff;"
            :to="{ path: `/analytic-sub?DeptID=${deptid}`}"
          >
            <feather-icon
              style="margin-bottom: 5px;"
              size="26"
              icon="ArrowLeftIcon"
            /><span style="color: #00FF80;"> วิเคราะห์ผู้บุกรุกพื้นที่ : </span>{{ detail }}
          </b-link>
          <a
            :href="anydesk"
            class="large-dropdown ml-1 ms-3"
          >
            <b-button
              size="sm"
              variant="outline-danger"
            ><b-img
              src="@/assets/images/logo/anydesk.png"
              style="height: 16px; width: 16px;"
            />
            <!-- <span style="color:#fff;"> {{ anydesk1 }}</span> -->
            </b-button>
          </a>
        </div>
      </b-col>
      <b-col
        lg="6"
        md="6"
        sm="12"
        class="text-right"
      >
        <a class="mr-2">
          <feather-icon
            v-b-modal="'LiveAnalyticSpeaker'"
            :style="{ color: iconColor }"
            icon="CameraIcon"
            size="30"
          />
        </a>

        <b-button
          v-b-modal="'modalCrosswalk'"
          variant="outline-danger"
          style="font-size: 16px; color: #fff; background-color: #000000;"
        >
          <span style="color: #fff; text-shadow: 0 0 2px #fff; margin-right: 5px;"> ผู้บุกรุก </span>
          <span style="color: #ff5252; text-shadow: 0 0 6px #ff0000; font-size: 18px;">{{ intruso.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</span>
          <span style="color: #fff; text-shadow: 0 0 2px #fff; margin-left: 5px;"> คน </span>
        </b-button>
      </b-col>
      <LiveAnalyticSpeaker
        ref="RTSP"
      />
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="5"
        md="12"
        sm="12"
      >
        <b-row class="match-height">
          <b-col lg="12">
            <l-map
              ref="mymap"
              :zoom="zoom"
              :center="center"
              :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false}"
              style="width: 100%; height: 572px; z-index: 0"
            >
              <l-tile-layer :url="url" />
              <l-marker
                :lat-lng="markers"
                :options="{ autoClose: false, closeOnClick: false }"
                @click="getInfoCount(marker.WayID, marker.detail, marker.wid)"
              >
                <l-icon
                  :icon-size="[28, 40]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/icons/detection/detectiony.svg')"
                />
              </l-marker>
            </l-map>
          </b-col>
          <b-col lg="12">
            <br>
            <AnalyticSpeaker-RTSP />
          </b-col>
        </b-row>
      </b-col>

      <!-- chart+table -->
      <b-col lg="7">
        <div>
          <b-row>
            <b-col lg="12">
              <AnalyticSpeaker-Chart />
            </b-col>
            <b-col lg="12">
              <AnalyticSpeaker-Table />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <Modal-AnalyticSpeaker-Table />
  </div>
</template>

<script>
/* eslint-disable global-require */
import Hls from 'hls.js'
import {
  BRow, BCol, BLink, BButton, BImg,
} from 'bootstrap-vue'
import {
  LMap, LMarker, LIcon, LTileLayer,
  // LPopup,
} from 'vue2-leaflet'
import axios from '@axios'
import { Icon, CRS } from 'leaflet'
import AnalyticSpeakerRTSP from './AnalyticSpeakerRTSP.vue'
import AnalyticSpeakerChart from './AnalyticSpeakerChart.vue'
import AnalyticSpeakerTable from './AnalyticSpeakerTable.vue'
import ModalAnalyticSpeakerTable from './ModalAnalyticSpeakerTable.vue'
import LiveAnalyticSpeaker from './ModalRTSP.vue'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BButton,
    BImg,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    // LPopup,
    AnalyticSpeakerRTSP,
    AnalyticSpeakerChart,
    AnalyticSpeakerTable,
    ModalAnalyticSpeakerTable,
    LiveAnalyticSpeaker,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 17,
      center: [0, 0],
      imageBounds: [[0, 0], [0, 0]],
      crs: CRS.Simple,
      deptid: '',
      detail: '',
      markers: [0, 0],
      checkcam: '',
      anydesk: '',
      userData: JSON.parse(localStorage.getItem('userData')),
      intruso: '',

      iconColor: 'rgba(255, 174, 0, 1)',
    }
  },
  created() {
  },
  mounted() {
    this.checkCam()
    this.getdetailAnalyticSpeaker()
    this.getDataAnalyticSpeaker()
    this.interval = setInterval(() => {
      this.checkCam()
      this.getdetailCrossWalk()
      this.getDataCrosswalkScifi()
    }, 300000)
  },
  methods: {
    checkCam() {
      axios
        .post('/checkCamCrossWalk', { wid: this.$route.query.wid })
        .then(response => {
          this.checkcam = response.data[0].check_cam
          console.log(this.countPhase)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getdetailAnalyticSpeaker() {
      axios
        .post('/detailCrossWalk', { wid: this.$route.query.wid })
        .then(response => {
          this.center = []
          this.markers = []
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
          this.markers.push(response.data[0].latitude)
          this.markers.push(response.data[0].longitude)
          this.deptid = response.data[0].deptid
          this.detail = response.data[0].detail
          this.anydesk = `anydesk:${response.data[0].anydesk}`
        })
        .catch(error => {
          console.log(error)
        })
    },
    stream(value, camdesc) {
      setTimeout(() => {
        this.camdesc = camdesc
        const hls = new Hls({
          lowLatencyMode: true,
          autoreconnect: true,
        })
        const stream = value
        const video = document.querySelector('#video')
        hls.loadSource(stream)
        hls.attachMedia(video)
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
        hls.on(Hls.Events.ERROR, () => {
          video.play()
        })
      }, 500)
    },

    onMapReady(mapObject) {
      // Get the size of the map container
      const mapSize = mapObject.getSize()

      // Calculate the bounds to fit the image to the map
      const southWest = mapObject.unproject([0, mapSize.y], mapObject.getZoom())
      const northEast = mapObject.unproject([mapSize.x, 0], mapObject.getZoom())

      // Update the imageBounds
      this.imageBounds = [southWest, northEast]

      // Fit the map to these bounds
      mapObject.fitBounds(this.imageBounds)
    },
    // ... other methods ...

    getDataAnalyticSpeaker() {
      axios.post('/valueIntruder', { wid: this.$route.query.wid })
        .then(response => {
          this.intruso = response.data[0].intruso
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.leaflet-popup-content {
    margin: 10px 10px;
    width: 250px;
    height: 100%;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
    background: rgba(36, 36, 36, 0.95);
    box-shadow: 0 3px 14px rgba(0,0,0,0.4);
    /* Green */
    border: 1px solid #00B058;
    border-radius: 12px 12px 12px 12px;
}
.large-dropdown .dropdown-menu {
  min-width: 100px; /* Adjust width as needed */
  font-size: 12px; /* Smaller font size */
  padding: 5px; /* Smaller padding */
}
.large-dropdown .btn {
  padding: 0.25rem 0.5rem; /* Smaller button padding */
  font-size: 0.875rem; /* Smaller text on the dropdown button */
}
</style>
